import { useAtomValue } from 'jotai'
import { FC } from 'react'

import { initialGraph } from 'src/v2/state/owner-reveal/graph'
import { GraphVisual } from 'src/v2/components/graph-widget/utils'
import { GraphEmpty } from 'src/v2/components/graph-widget/empty'

type GraphWidgetProps = {
  id: string
  type: 'entity' | 'parcel'
  hideLegend?: boolean
}

type GraphProps = {
  initialData: GraphVisual
} & GraphWidgetProps

export const Graph: FC<GraphProps> = (props) => {
  return null
}

export const GraphWidget: FC<GraphWidgetProps> = (props) => {
  const initialData = useAtomValue(initialGraph({ id: props.id, type: props.type }))

  if (!initialData) {
    return <GraphEmpty />
  }

  return <Graph {...props} initialData={initialData} />
}
